/**
 * Production Lightstone retrieve and Virtual Agent lookup run on the
 * africa-south1 Cloud Run box. Local CRA talks to :5001 (empty base).
 */
export function cloudRunFetchBase() {
    return process.env.REACT_APP_LIGHTSTONE_FETCH_BASE
        || (process.env.NODE_ENV === 'production'
            ? 'https://ipm-lightstone-fetch-541421913321.africa-south1.run.app'
            : '');
}

export function saIdsFrom(...parts) {
    const blob = parts.map((p) => String(p || '')).join(' ');
    const seenStem = new Set();
    const out = [];
    for (const hit of blob.match(/\d{13}/g) || []) {
        const mm = Number(hit.slice(2, 4));
        const dd = Number(hit.slice(4, 6));
        if (mm < 1 || mm > 12 || dd < 1 || dd > 31) continue;
        const stem = hit.slice(0, 12);
        if (seenStem.has(stem)) continue;
        seenStem.add(stem);
        out.push(hit);
    }
    return out;
}
